import types from './types';

export const toggleCompactMode = () => ({
  type: types.TOGGLE_COMPACT_MODE
});

export const setDirty = () => ({
  type: types.SET_DIRTY
});
